import React from 'react'
import styled from 'styled-components'
import Expertise from './Expertise'
import { Title } from '../common/styled'
import {
  Wrapper,
  Text,
  getTitle,
  getSubtitle
} from './shared'

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width:100%;
`

export const SubTitle = styled.p`
  font-family: ${props => props.theme.fonts.Montserrat};
  font-size: 11px;
  color: ${props => props.theme.colors.blueGrey};
  padding-top: 30px;
  padding-bottom: 10px;
  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
`

const textOptions = {
  fontSize: '11',
  pl: '0px',
  pb: '10px'
}

export const CredentialList = ({ data, name, count }) => {
  if (name === 'expertise') {
    return <Expertise data={data} name={name} count={count} />
  }

  const showDate = name !== 'certifications'
  return (
    <Wrapper count={count} noHeight>
      <Title pl='0px'>{getTitle[name]}</Title>
      <ContentWrapper>
        <SubTitle {...textOptions}>{getSubtitle[name]}</SubTitle>
        {showDate && <SubTitle {...textOptions}>DATE</SubTitle>}
      </ContentWrapper>
      {data.map((item, i) => (
        <ContentWrapper key={i}>
          <Text>{item.description}</Text>
          {showDate && <Text>{item.effectiveYear}</Text>}
        </ContentWrapper>
      ))}
    </Wrapper>
  )
}

export default CredentialList
